import { RouterModule, Routes } from '@angular/router';
import { OpsDashboardComponent } from './pages/ops-dashboard/ops-dashboard.component';
import { OpsMimicsComponent } from './layout/ops-mimics/ops-mimics.component';
import { OpsAlarmComponent } from './pages/ops-alarm/ops-alarm.component';
import { OpsTrendGraphComponent } from './pages/ops-trend-graph/ops-trend-graph.component';
import {
    OpsChannelViewsComponent,
    CanAdvancedChannelViewsDeactivate,
} from './pages/ops-channel-views/ops-channel-views.component';
import { ProjectSettingsFormComponent } from '@components/project-settings-form/project-settings-form.component';
import { MatDialogRef } from '@angular/material/dialog';
import { OpsGraphsComponent } from '@pages/ops-graphs/ops-graphs.component';
import { OpsSystemStatusComponent } from '@pages/ops-system-status/ops-system-status.component';
import { CustomGraphCreateComponent } from '@pages/ops-graphs/custom-graph-create/custom-graph-create.component';

export const appRoutes: Routes = [
    { path: '', component: OpsDashboardComponent },
    {
        path: 'ops/dashboard',
        component: OpsDashboardComponent,
    },
    {
        path: 'ops/mimics/:id',
        component: OpsMimicsComponent,
    },
    {
        path: 'ops/alarms',
        component: OpsAlarmComponent,
    },
    {
        path: 'ops/trendgraphs',
        children: [
            { path: '', component: OpsTrendGraphComponent },
            {
                path: ':viewOption',
                component: OpsTrendGraphComponent,
                runGuardsAndResolvers: 'always',
                canDeactivate: [OpsTrendGraphComponent.CanDeactivate],
            },
            {
                path: ':viewOption/:editOption',
                component: OpsTrendGraphComponent,
                runGuardsAndResolvers: 'always',
                canDeactivate: [OpsTrendGraphComponent.CanDeactivate],
            },
        ],
    },
    {
        path: 'ops/graphs',
        children: [
            { path: '', component: OpsGraphsComponent },
            {
                path: 'create',
                component: CustomGraphCreateComponent,
                runGuardsAndResolvers: 'always',
                canDeactivate: [CustomGraphCreateComponent.CanDeactivate],
            },
            {
                path: 'create/:customGraphId',
                component: CustomGraphCreateComponent,
                runGuardsAndResolvers: 'always',
                canDeactivate: [CustomGraphCreateComponent.CanDeactivate],
            },
            {
                path: ':customGraphId',
                component: OpsGraphsComponent,
            },
        ],
    },
    {
        path: 'ops/groups',
        children: [
            {
                path: '',
                component: OpsChannelViewsComponent,
                canDeactivate: [OpsChannelViewsComponent.CanDeactivate],
            },
            {
                path: ':groupId/channels',
                component: OpsChannelViewsComponent,
                canDeactivate: [OpsChannelViewsComponent.CanDeactivate],
            },
            {
                path: ':groupId/channels/:fcuChannelId',
                component: OpsChannelViewsComponent,
            },
            {
                path: ':groupId/channels/:fcuChannelId/advanced',
                component: OpsChannelViewsComponent,
                canDeactivate: [CanAdvancedChannelViewsDeactivate],
            },
        ],
    },
    {
        path: 'ops/system-status',
        children: [{ path: '', component: OpsSystemStatusComponent }],
    },
    {
        path: 'settings',
        component: ProjectSettingsFormComponent,
        providers: [{ provide: MatDialogRef, useValue: {} }],
    },

    // { path: '**', redirectTo: '/' },
];

export const routing = RouterModule.forRoot(appRoutes, {});
